/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Siddhesh",
  title: "Hi All, I'm Siddhesh",
  subTitle:
    "A Software Engineer 🚀 passionate about building scalable native Android apps and full-stack web experiences using Kotlin, React, Node.js, and React Native — with a deep love for open source and clean architecture.",
  resumeLink: "https://drive.google.com/file/d/1-Db-YoZ7vbJe6C9v4qLZuSQmk8FXQu1M/view?usp=sharing",
  // Android / Web - https://drive.google.com/file/d/1-Db-YoZ7vbJe6C9v4qLZDSQmk8FXQu1M/view?usp=sharing
  // Android specific - https://drive.google.com/file/d/1FLCFioF1wJwA6mUwX9RRKo1GGmE6rjPA/view?usp=sharing
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/siddhesh-06",
  linkedin: "https://www.linkedin.com/in/siddheshdhainje/",
  gmail: "siddheshdhainje2024@gmail.com",
  gitlab: "https://leetcode.com/u/siddhesh36/",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "A SOFTWARE ENGINEER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Experienced in developing robust, scalable, and production-grade native Android applications using Java, Kotlin, Jetpack components, MVVM, and MVI architecture — with hands-on expertise across enterprise domains including MDM, VPN, and POS systems."
    ),
    emoji("⚡ Proficient in full-stack development, building RESTful APIs with Node.js & Express.js and integrating them with React.js & React Native for seamless cross-platform web and mobile experiences across Retail and Healthcare clients."),
    emoji("⚡ Strong command of software architecture and system design, applying SOLID principles, design patterns, multithreading, and concurrency mechanisms — including Kotlin Coroutines, Mutex synchronization, and WorkManager — for optimized, fault-tolerant performance in high-throughput environments."),
    emoji("⚡ Active open-source contributor to real-world Android projects driven by a genuine passion for the Android ecosystem, large codebase exploration, and continuous learning..")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Android",
      dataIcon: "devicon:android"
    },
    {
      skillName: "Java",
      dataIcon: "logos:java"
    },
    {
      skillName: "Kotlin",
      dataIcon: "devicon:kotlin"
    },
    {
      skillName: "React-Native",
      dataIcon: "vscode-icons:file-type-reactts"
    },
    {
      skillName: "JavaScript",
      dataIcon: "logos:javascript"
    },
    {
      skillName: "Golang",
      dataIcon: "skill-icons:golang"
    },
    {
      skillName: "html-5",
      dataIcon: "vscode-icons:file-type-html"
    },
    {
      skillName: "css3",
      dataIcon: "vscode-icons:file-type-css"
    },

    {
      skillName: "Reactjs",
      dataIcon: "vscode-icons:file-type-reactjs"
    },
    {
      skillName: "NodeJs",
      dataIcon: "vscode-icons:file-type-node"
    },
    {
      skillName: "NPM",
      dataIcon: "vscode-icons:file-type-npm"
    },

    {
      skillName: "Firebase",
      dataIcon: "vscode-icons:file-type-firebase"
    },
    {
      skillName: "MongoDB",
      dataIcon: "vscode-icons:file-type-mongo"
    },
    {
      skillName: "Redux",
      dataIcon: "logos:redux"
    },
    {
      skillName: "React-Query",
      dataIcon: "logos:react-query-icon"
    },


    // {
    //   skillName: "NextJs",
    //   dataIcon: "devicon:nextjs"
    // },
    {
      skillName: "tailwind",
      dataIcon: "devicon:tailwindcss"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "PUNE INSTITUTE OF COMPUTER TECHNOLOGY",
      logo: require("./assets/images/pict.png"),
      subHeader: "B.E (INFORMATION TECHNOLOGY)",
      duration: "2019 - 2023",
      desc: "Current CGPA:  9.16/10",
      descBullets: [
        "Member at PICT ACM Student Chapter",
        "Created sites and managed events of PASC",
        "Conducted SIG sessions on Web development"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Integration", //Insert stack or technology you have experience in
      progressPercentage: "80%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "60%"
    },
    {
      Stack: "Programming",
      progressPercentage: "85%"
    }
  ],
  displayCodersrank: false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Global Payments",
      companyUrl: "https://www.globalpayments.com",
      companylogo:
        "https://imgs.search.brave.com/H1PBcP-CHJt2dtpXR4DeQ46P4mpBSd0zmggB2t86qWc/rs:fit:200:200:1:0/g:ce/aHR0cHM6Ly95dDMu/Z29vZ2xldXNlcmNv/bnRlbnQuY29tLzdX/OGNoNXotR3FydmEt/bWluWjBhZHBMZWN2/LTI3LVZFYmRqRlZm/WWJXX3lUUmc0SklQ/MzZjVFJuMWNLWjlz/dTN0bHBtOVc4NF9B/PXM5MDAtYy1rLWMw/eDAwZmZmZmZmLW5v/LXJq",
      date: "March 2025 – Present",
      desc: "A complete worldwide commerce ecosystem.Delivering for you",
      descBullets: [
        "I work on Genius, the company's flagship POS product.",
        "Implemented the Appointments Module from scratch, utilizing Paging 3 for paginated appointment listings and StateFlow for reactive, lifecycle-aware UI state management.",
        "Migrated legacy transaction services from AsyncTask to Kotlin Coroutines, applying Mutex and other synchronization mechanisms to eliminate race conditions, memory leaks, and SQL deadlocks in high-throughput transaction workflows.",
        "Built custom Android memory diagnostics tooling covering Java heap tracking, GC detection, and native memory monitoring — which goes well beyond typical app development into Android internals.",
      ]
    },
    {
      role: "Associate Product Engineer",
      company: "ProMobi Technologies",
      companyUrl: "https://promobitech.com/",
      companylogo: require("./assets/images/promobi.png"),
      date: "Jan 2023 – March 2025",
      desc: "We help you adapt to the digital age by building innovative online products that help scale your business.",
      descBullets: [
        "Implemented critical device security and control features by integrating enterprise SDKs including Samsung Knox and Lenovo CSDK, enhancing product capabilities for enterprise clients.",
        "Designed and developed Veltar, a Android VPN module enabling web content filtering, allowing IT admins to enforce website restrictions and providesecure, role-based access to private organizational resources.",
        "Led R&D and end-to-end integration of AMAPI Zero Touch SDK, leveraging its capabilities to capture device, network, and hardware signals preenrollment, streamlining zero-touch provisioning for the MDM platform.",
        "Developed an in-house Android application for IT administrators to efficiently manage the full lifecycle of IT devices, reducing manual overhead and improving operational efficiency."
      ]
    },
    {
      role: "Full Stack Developer Intern",
      company: "DWeb-Box",
      companyUrl: "https://dwebbox.com/#home",
      companylogo: require("./assets/images/dwebbox.jpeg"),
      date: "April 2021 – Jan 2022",
      desc: "We help you adapt to the digital age by building innovative online products that help scale your business.",
      descBullets: [
        "Built cross-platform mobile apps and website portal for Retail and Healthcare clients using ReactJs, Redux, React-Native and ExpressJs collaborating with designers and QA to ensure smooth backend integration and consistent user experience.",
        "Developed REST APIs using Node & Express js & also performed APIs integration using Redux and React-Query.",
        "Responsible for building and maintaining full-stack applications."
      ]
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "Key projects I contributed to during my tenure at previous companies",
  projects: [
    {
      image:
        "https://scalefusion.com/assets/scalefusion_v4/index/ic_veltar-8998a3cd51ed76360ea41658c7cf789ba80627fd2345caa1c4dbba572994e8ca.svg",
      projectName: "Veltar",
      projectDesc:
        "Built an Android module named Veltar that provides web content filtering and acts as a mediator for accessing private organization sites",
      footerLink: [
        {
          name: "Description Link",
          url: "https://scalefusion.com/products/veltar"
        }
        //  you can add extra buttons here.
      ],
      icons: [
        {
          skillName: "Android",
          dataIcon: "devicon:android"
        },
        {
          skillName: "Java",
          dataIcon: "logos:java"
        },
        {
          skillName: "Kotlin",
          dataIcon: "devicon:kotlin"
        },
        {
          skillName: "Golang",
          dataIcon: "skill-icons:golang"
        },
      ]
    },
    {
      image: require("./assets/images/scalefusion.png"),
      projectName: "Scalefusion",
      projectDesc:
        "Mobile Device Management (MDM) platform that allows IT admins to remotely manage, secure, and monitor enterprise devices",
      footerLink: [
        {
          name: "Description Link",
          url: "https://scalefusion.com/mobile-device-management"
        }
        //  you can add extra buttons here.
      ],
      icons: [
        {
          skillName: "Android",
          dataIcon: "devicon:android"
        },
        {
          skillName: "Java",
          dataIcon: "logos:java"
        },
        {
          skillName: "Kotlin",
          dataIcon: "devicon:kotlin"
        },
      ]
    },
    {
      image:
        "https://play-lh.googleusercontent.com/bnxg-QFWUDzwO-9JLji1wVg3xzdrX02Oy4zpQp1fyBQQom36QystX2V1yuCYeGAVvQ=w240-h480-rw",
      projectName: "GenWE",
      projectDesc:
        "GenWE platform that pairs you with a teen from a different background& also help you develop valuable life skills",
      footerLink: [
        {
          name: "Play Store Link",
          url: "https://play.google.com/store/apps/details?id=com.genwemobile&hl=en&gl=US&pli=1"
        }
        //  you can add extra buttons here.
      ],
      icons: [
        {
          skillName: "React-Native",
          dataIcon: "vscode-icons:file-type-reactts"
        },
        {
          skillName: "Redux",
          dataIcon: "logos:redux"
        },
        {
          skillName: "NodeJs",
          dataIcon: "vscode-icons:file-type-node"
        },
        {
          skillName: "React-Query",
          dataIcon: "logos:react-query-icon"
        }
      ]
    },
    {
      image: require("./assets/images/amyraa2.png"),
      projectName: "Amyraa",
      projectDesc: "Unparalleled jewellery collection, explore vast range of crafted jewellery",
      footerLink: [
        {
          name: "Play Store Link",
          url: "https://play.google.com/store/apps/details?id=com.amyra"
        }
      ],
      icons: [
        {
          skillName: "React-Native",
          dataIcon: "vscode-icons:file-type-reactts"
        },
        {
          skillName: "Redux",
          dataIcon: "logos:redux"
        },
        {
          skillName: "NodeJs",
          dataIcon: "vscode-icons:file-type-node"
        },
        {
          skillName: "React-Query",
          dataIcon: "logos:react-query-icon"
        }
      ]
    },
    {
      image: require("./assets/images/logo3.png"),
      projectName: "Surgeons For Surgeons",
      projectDesc:
        "A social platform for surgeons used by over 600+ surgeons across the world.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://surgeonsforsurgeons.com/#/home"
        }
      ],
      icons: [
        {
          skillName: "Reactjs",
          dataIcon: "vscode-icons:file-type-reactjs"
        },
        {
          skillName: "NodeJs",
          dataIcon: "vscode-icons:file-type-node"
        },
        {
          skillName: "MySQL",
          dataIcon: "logos:mysql"
        }
      ]
    },
    {
      image: require("./assets/images/medvatic.png"),
      projectName: "Medvatic",
      projectDesc:
        "A patient centered digital service having 200+ users worldwide.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://medvatic.com/#/"
        }
      ],
      icons: [
        {
          skillName: "Reactjs",
          dataIcon: "vscode-icons:file-type-reactjs"
        },
        {
          skillName: "NodeJs",
          dataIcon: "vscode-icons:file-type-node"
        },
        {
          skillName: "Firebase",
          dataIcon: "logos:firebase"
        }
      ]
    },

  ],
  display: true // Set false to hide this section, defaults to true
};

const myProjects = {
  title: "Projects",
  subtitle: "Here are some of my personal projects. To explore more ",
  projects: [
    {
      image: require("./assets/images/Pega1.png"),
      projectName: "Pega",
      projectDesc: "Simplify PDF uploads, extract insights with our intelligent Pega. Effortlessly engage and unlock valuable data. Streamline your workflow with our SaaS solution.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://pega-liard.vercel.app/"
        }
      ],
      icons: [
        {
          skillName: "Nextjs",
          dataIcon: "devicon:nextjs"
        },
        {
          skillName: "Typescript",
          dataIcon: "devicon:typescript"
        },
        {
          skillName: "Tailwind",
          dataIcon: "devicon:tailwindcss"
        },
        {
          skillName: "OpenAI",
          dataIcon: "simple-icons:openai"
        },
        {
          skillName: "Postgresql",
          dataIcon: "devicon:postgresql"
        }
      ]
    },
    {
      image: require("./assets/images/splash.png"),
      projectName: "Istreewala",
      projectDesc:
        "The app was developed with the aim to provide an elegant and effective way to manage and keep track of the orders taken by laundry service personnel.",
      footerLink: [
        {
          name: "G-drive link",
          url: "https://drive.google.com/file/d/1PISdFwcIYZNdXdreT7f2dPxM_lVMo64-/view"
        }
        //  you can add extra buttons here.
      ],
      icons: [
        {
          skillName: "React-Native",
          dataIcon: "vscode-icons:file-type-reactts"
        },
        {
          skillName: "Redux",
          dataIcon: "logos:redux"
        },
        {
          skillName: "NodeJs",
          dataIcon: "vscode-icons:file-type-node"
        },
        {
          skillName: "Firebase",
          dataIcon: "logos:firebase"
        }
      ]
    },
    {
      image: require("./assets/images/devconnector.png"),
      projectName: "Dev-Connector",
      projectDesc:
        "This web application is similar to social media app. In this web app user can create their own profile and post, also comment and like other posts.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://dev-connector2023.onrender.com/"
        }
      ],
      icons: [
        {
          skillName: "Reactjs",
          dataIcon: "vscode-icons:file-type-reactjs"
        },
        {
          skillName: "NodeJs",
          dataIcon: "vscode-icons:file-type-node"
        },
        {
          skillName: "MongoDB",
          dataIcon: "vscode-icons:file-type-mongo"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  // title: emoji("Achievements And Certifications 🏆 "),
  title: emoji("Certifications🏆 "),
  //subtitle: "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Java Multi-threading Concurrency & Performance Optimization",
      subtitle: "Udemy",
      image: require("./assets/images/udemy2.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1r3-29Em_wOlV6z5SHtURxaa8IEi9jJVe/view?usp=sharing"
        }
      ]
    },
    {
      title: "Java Design Patterns & Solid Design Principle",
      subtitle: "Udemy",
      image: require("./assets/images/udemy2.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1zEbY7D6E6qAt7fH_1jWryFPKywbmqN3H/view?usp=drivesdk"
        }
      ]
    },
    {
      title: "Android Enterprice Certified Professional",
      subtitle: "Android Enterprice",
      image: require("./assets/images/android-certification-course.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1uwVLttxdvWUJ9PuLmnARSUdktmOFLXu7/view"
        }
      ]
    },
    {
      title: "AWS Academy Graduate",
      subtitle: "AWS Academy Cloud Foundations",
      image: require("./assets/images/aws5.png"),
      footerLink: [
        {
          name: "Certification",
          url: "https://www.credly.com/badges/949ab7e3-f158-44c8-a6f5-dc41caf7a6a7"
        }
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+91-9022828336",
  email_address: "siddheshdhainje2024@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  myProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
